module.exports = __webpack_public_path__ + "static/media/web_hacktivoverflow.a8f26e5d.png";